import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getProfile: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/me', data),
};

// Works API
export const worksAPI = {
  create: (data) => api.post('/works', data),
  list: (params) => api.get('/works', { params }),
  get: (id) => api.get(`/works/${id}`),
  update: (id, data) => api.put(`/works/${id}`, data),
  delete: (id) => api.delete(`/works/${id}`),
  togglePublic: (id, isPublic) => api.put(`/works/${id}`, { public_gallery: isPublic }),
  uploadFile: (id, file, fileType) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('file_type', fileType);
    return api.post(`/works/${id}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  uploadAudio: (id, formData) => {
    return api.post(`/works/${id}/audio`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  downloadFile: (workId, gridfsId) => 
    api.get(`/works/${workId}/files/${gridfsId}`, { responseType: 'blob' }),
  generateCertificate: (id) => api.post(`/works/${id}/certificate`),
  downloadCertificate: (id) => 
    api.get(`/works/${id}/certificate/pdf`, { responseType: 'blob' }),
};

// Public API
export const publicAPI = {
  verifyCertificate: (hash) => api.get(`/verify/${hash}`),
};

export default api;
